import React from 'react'

import PropTypes from 'prop-types'

import Question from './question'
import './perguntas-frequentes.css'

const PerguntasFrequentes = (props) => {
  return (
    <div className={`perguntas-frequentes-frame1011 ${props.rootClassName} `}>
      <div className="perguntas-frequentes-frame81">
        <span className="perguntas-frequentes-text1">
          <span>Perguntas Frequentes</span>
        </span>
        <span className="perguntas-frequentes-text3">
          <span>
            Antecipe suas dúvidas e obtenha respostas transparentes. Minha seção
            de Perguntas Frequentes é projetada para fornecer clareza e
            orientação prévia.
          </span>
        </span>
      </div>
      <div className="perguntas-frequentes-frame1012">
        <div className="perguntas-frequentes-question03">
          <img
            alt="Vector312841"
            src="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/6f326eaf-f4c0-46c4-a5b5-80d04aecf10d/6ef01cd0-fa52-4b83-8e58-67135493fb69?org_if_sml=1203&amp;force_format=original"
            className="perguntas-frequentes-vector31"
          />
          <span className="perguntas-frequentes-text5">
            <span>Lorem Ipsum</span>
          </span>
          <Question
            head="Pergunta 1"
            content="Resposta 1"
            rootClassName="questionroot-class-name"
          ></Question>
          <Question
            head="Pergunta 2"
            content="Resposta 2"
            rootClassName="questionroot-class-name1"
          ></Question>
          <Question
            head="Pergunta 3"
            content="Resposta 3"
            rootClassName="questionroot-class-name5"
          ></Question>
          <Question
            head="Pergunta 4"
            content="Resposta 4"
            rootClassName="questionroot-class-name4"
          ></Question>
          <Question
            head="Pergunta 5"
            content="Resposta 5"
            rootClassName="questionroot-class-name3"
          ></Question>
          <Question
            head="Pergunta 6"
            content="Resposta 6"
            rootClassName="questionroot-class-name2"
          ></Question>
        </div>
      </div>
    </div>
  )
}

PerguntasFrequentes.defaultProps = {
  rootClassName: '',
}

PerguntasFrequentes.propTypes = {
  rootClassName: PropTypes.string,
}

export default PerguntasFrequentes
